
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/discover-more/related-projects",
      function () {
        return require("private-next-pages/material-ui/discover-more/related-projects.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/discover-more/related-projects"])
      });
    }
  